import { User, Auditoria } from './';

export class UserAuditoria {
    usuario: User;
    auditoria?: Auditoria;
}
